'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * A hook for detecting hovering (mouse enter and mouse leave) over an element
 * @param options UseHoverOptions
 * @returns UseHoverReturn
 */ const useHover = (options = {})=>{
    const { delayEnter =0 , delayLeave =0  } = options;
    const [hovered, setHovered] = React.useState(false);
    let mouseEnterTimer;
    let mouseOutTimer;
    return {
        hovered,
        hoverProps: {
            onMouseEnter: ()=>{
                clearTimeout(mouseOutTimer);
                mouseEnterTimer = setTimeout(()=>setHovered(true), delayEnter);
            },
            onMouseLeave: ()=>{
                clearTimeout(mouseEnterTimer);
                mouseOutTimer = setTimeout(()=>setHovered(false), delayLeave);
            }
        },
        setHovered
    };
};

exports.useHover = useHover;
//# sourceMappingURL=use-hover.js.map
